import React from 'react';
import { toAbsoluteUrl } from '../../../../../../_start/helpers';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { WebsiteScreenshot } from './WebsiteScreenshot';

type WebsiteScreenshotMobileProps = {
  data: WebsiteScreenshot;
  update: (fieldsToUpdate: Partial<WebsiteScreenshot>) => void;
};

export const WebsiteScreenshotMobile = ({
  data,
  update,
}: WebsiteScreenshotMobileProps) => {
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}-mobile`}
        name={`image_preview_mobile`}
        altText={`image_preview_mobile_alt`}
        update={update}
      />

      {/* begin::Website Screenshot Mobile */}
      <div className="smartphone smartphone--white smartphone--outside">
        {data.image_preview_mobile ? (
          <div className="overlay">
            <div className="overlay-wrapper">
              <img
                alt="dummy"
                src={data.image_preview_mobile}
                style={{
                  width: '100%',
                  height: '519px',
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className="overlay-layer bg-dark bg-opacity-10 flex-column">
              <div>
                <button
                  name="image_preview_mobile"
                  className="btn btn-primary btn-shadow"
                  onClick={() =>
                    update({
                      image_preview_mobile: '',
                      image_preview_mobile_alt: '',
                    })
                  }
                >
                  Remove
                </button>
                <label
                  className="btn btn-light-primary btn-shadow ms-2"
                  data-bs-toggle="modal"
                  data-bs-target={`#${data.name}-${data.id}-mobile`}
                >
                  Change
                </label>
              </div>

              <input
                placeholder="Alt attribute"
                className="w-50 mt-2 form-control form-control-lg form-control-solid"
                type="text"
                value={data.image_preview_mobile_alt ?? ''}
                onChange={(event) =>
                  update({ image_preview_mobile_alt: event.target.value })
                }
              />
            </div>
          </div>
        ) : (
          <>
            <label
              data-bs-toggle="modal"
              data-bs-target={`#${data.name}-${data.id}-mobile`}
            >
              <img
                src={toAbsoluteUrl('/assets/images/400x679.webp')}
                alt=""
                style={{
                  width: '100%',
                  height: '525px',
                  objectFit: 'cover',
                }}
              />
            </label>
          </>
        )}
      </div>
      {/* end::Website Screenshot Mobile */}
    </>
  );
};
